import { useContext } from 'react'

import FixedLayout from '~/components/FixedLayout'
import { NavigationContext } from '~/core/NavigationConfig'

export default function ResponsiveLayout(props: any) {
    const { children } = props

    const { navigationConfig } = useContext(NavigationContext)

    return (
        <FixedLayout
            trigger
            collapsedWidth="0"
            minWidth="auto"
            breakpoint="sm"
            {...props}
            {...navigationConfig}
        >
            {children}
        </FixedLayout>
    )
}
